import { nextTick, ref } from "vue";

export const destoryAllCache = ref(true)
export const clearAlCache = async () => {
    destoryAllCache.value = false
    await nextTick()
    destoryAllCache.value = true
}